import { useMemo } from "react";

const range = (start, stop) =>
  Array.from({ length: stop - start }, (_, i) => start + i);
const CreatePagination = (pageSize, totalCount, siblingCount, currentPage) =>
  useMemo(() => {
    const totalPageCount = Math.ceil(totalCount / pageSize);

    const pageNumber = 5 + siblingCount;

    if (totalPageCount < pageNumber) return range(1, totalPageCount+1);

    const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);

    const rightSiblingIndex = Math.min(
      currentPage + siblingCount,
      totalPageCount
    );

    const showLeftDots = leftSiblingIndex > 2;
    const showRightDots = rightSiblingIndex < totalPageCount - 2;

    if (!showLeftDots && showRightDots) {
      let leftItemCount = 3 + 1 * siblingCount;
      const leftItems = range(1, leftItemCount);
      return [...leftItems, "...", totalPageCount];
    }

    if (showLeftDots && !showRightDots) {
      let rightItemCount = 3 + 1 * siblingCount;
      const rightItems = range(
        totalPageCount - rightItemCount + 1,
        totalPageCount + 1
      );
      return [1, "...", ...rightItems];
    }

    if (showLeftDots && showRightDots) {
      const middleItems = range(currentPage - 1, currentPage + 2);
      return [1, "...", ...middleItems, "...", totalPageCount];
    }

    if (!showLeftDots && !showRightDots) {
      const middleItems = range(currentPage, currentPage + 2);
      return [1, "...", ...middleItems, "...", totalPageCount];
    }
  }, [pageSize, totalCount, siblingCount, currentPage]);

export default CreatePagination;
